var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlogPaginationList',{attrs:{"title":_vm.$t('newsBlogPage.heading'),"postsTag":"NEWS_LAND_USE","routeName":"news_blog","limit":3}})}
var staticRenderFns = []

export { render, staticRenderFns }